import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import {
  CreateNote,
  FindManyNotes,
  Note,
  PaginateResult,
} from '@univacity/shared/types';
import { ObjectUtil } from '@univacity/shared/util';
import { Observable } from 'rxjs';
import { Configuration } from '../config/configuration';

@Injectable({
  providedIn: 'root',
})
export class NoteService {
  private baseUrl: string;

  constructor(private http: HttpClient, private config: Configuration) {
    this.baseUrl = this.config.apiMainUrl + '/note';
  }

  create(body: CreateNote) {
    return this.http.post<Note>(this.baseUrl, body);
  }

  find(query: FindManyNotes = {}): Observable<PaginateResult<Note>> {
    const params = new HttpParams({
      fromObject: ObjectUtil.removeEmptyProperties(query) as Params,
    });
    return this.http.get<PaginateResult<Note>>(this.baseUrl, {
      params: params,
    });
  }

  count(query: FindManyNotes = {}): Observable<number> {
    const params = new HttpParams({
      fromObject: ObjectUtil.removeEmptyProperties(query) as Params,
    });
    return this.http.get<number>(`${this.baseUrl}/count`, {
      params: params,
    });
  }

  editNote(id: string, body: Note): Observable<Note> {
    return this.http.patch<Note>(`${this.baseUrl}/${id}`, body);
  }

  deleteNote(id: string) {
    return this.http.delete(`${this.baseUrl}/${id}`);
  }
}
